import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {
  PUB_AGENDA_SOLUTIONS_LIST,
  AGENDA_CATEGORY_LIST,
  AGENDA_SOLUTIONS_LIST,
} from "manager/http-constants";
import { AGENDA_SOLUTION_M301_TEMPLATE } from "manager/template-constant";
import { Table } from "primeng/table";
import { DICVALUES_API_CONSTANT } from "src/app/shared/constant/api-constant";
import {
  CONSTANT,
  ROLES,
  DICID_NUMBER,
  MATCH_TYPE,
} from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { AGENDA_SOLUTION_CONSTANT } from "../master/m301/constant";
import { PlatformComponent } from "../platform.component";
import { LoginService } from "src/app/shared/service/login.service";
import { MessageService } from "primeng/api";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { DataView } from "primeng/dataview";

@Component({
  selector: "app-c231",
  templateUrl: "./c231.component.html",
  styleUrls: ["./c231.component.scss", "../platform.component.scss"],
})

/**
 * 課題・ソリューション一覧
 */
export class C231Component extends PlatformComponent {
  // 画面.検索フォーム
  c201SearchForm: FormGroup = this.formBuilder.group({
    member_class_sub_id: [],
    member_municipalities: [],
    agenda_solution_desired_subject: [],
    agenda_solution_target_grade: [],
    agenda_solution_desired_location: [],
    agenda_solution_desired_dayweek: [],
    freeword: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild("table") table: Table;

  // 課題・ソリューション種別のAccordion開閉フラグ
  accordion_agenda_kbn: boolean = false;

  // 会員種別のAccordion開閉フラグ
  accordion_class_id: boolean = false;

  // カテゴリのAccordion開閉フラグ
  accordion_agenda_category_class_cd2: boolean = false;

  // カテゴリの中項目Accordion開閉フラグ
  accordion_agenda_category_class_cd2_detail = new Map();

  // 都道府県のAccordion開閉フラグ
  accordion_prefectures: boolean = false;

  // 都道府県の中項目Accordion開閉フラグ
  accordion_prefectures_detail = new Map();

  // 更新日のAccordion開閉フラグ
  accordion_update_date: boolean = false;

  // 業種のAccordion開閉フラグ
  accordion_industry_id: boolean = false;

  // SDGsゴールのAccordion開閉フラグ
  accordion_sdgs_goal: boolean = false;

  // 課題・ソリューション結果リスト
  resultTaskDataList: any[] = [];

  // 課題・ソリューション件数格納先
  countTaskData: number = 0;

  // セッション保存名
  sessionTagName: string = "c201SearchConditions";

  cartSelected: any[] = [];

  selectedCity: any;
  accordion_classes_support = new Map();
  selectedCategory: any[] = [];

  accordion_member_class_sub_id: boolean = false;
  accordion_member_municipalities: boolean = false;
  accordion_agenda_solution_desired_subject: boolean = false;
  accordion_agenda_solution_target_grade: boolean = false;
  accordion_agenda_solution_desired_location: boolean = false;
  accordion_agenda_solution_desired_dayweek: boolean = false;

  columnOrder: any;
  generateSearchItems: Object;
  isShowList: boolean = false;

  class_id: any;
  // dataView ソートカラム名
  sortField: string;
  // dataView ソート順 (1:昇順, -1:降順)
  sortOrder: number;
  // var multi mode
  modeMulti: boolean = false;
  allChecked: boolean = false;
  mobileLargeCategory: string[] = [];

  @ViewChild("dv")
  dv: DataView;
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private changeDetector: ChangeDetectorRef,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    this.resetSearch();
    /* ヘッダー情報取得処理(画面用) */
    this.dbOperationService
      .getHeaderList(AGENDA_SOLUTION_M301_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID)
      .subscribe((response) => {
        this.columnOrder = response.body;
      });

    await this.loginService.checkLoginUser()
    this.loginUser = this.loginService.getCurrentUser();

    this.getUserLoginInfo();

    // 辞書値リストを取得
    this.getSpecCodeList(
      DICID_NUMBER.MUNICIPALITIES,
      DICID_NUMBER.CLASS_SUB_ID_1,
      DICID_NUMBER.DESIRED_SUBJECT,
      DICID_NUMBER.TARGET_GRADE_AGENDA_SOLUTION,
      DICID_NUMBER.DESIRED_LOCATION_2,
      DICID_NUMBER.DESIRED_DAYWEEK
    );

    // 課題カテゴリを取得
    // this.getAgendaCategoryList();

    // 初期処理:クエリパラメータの設定
    this.setQueryParams();
  }

  public getUserLoginInfo() {
    // ユーザマスタに存在する場合
    this.class_id = this.loginUser?.class_id;
    // 課題・ソリューション結果を取得
    this.getResultTaskDataList();
  }

  private resetSearch() {
    this.c201SearchForm.reset();
    this.accordion_member_class_sub_id = false;
    this.accordion_member_municipalities = false;
    this.accordion_agenda_solution_desired_subject = false;
    this.accordion_agenda_solution_target_grade = false;
    this.accordion_agenda_solution_desired_location = false;
    this.accordion_agenda_solution_desired_dayweek = false;
  }

  /**
   * 初期処理:クエリパラメータの設定
   */
  private setQueryParams(): void {
    // クエリパラメータ.課題・ソリューション種別
    {
      // クエリパラメータ.課題・ソリューション種別を取得
      const agendaKbn = this.route.snapshot.queryParams.agenda_kbn;

      // 課題・ソリューション種別が存在するか否か
      if (agendaKbn) {
        // 課題・ソリューション種別が存在する場合

        // 課題・ソリューション種別を画面.検索フォームに格納
        this.c201SearchForm
          .get("agenda_kbn")
          .setValue(agendaKbn.split(CONSTANT.COMMA));

        // 課題・ソリューション種別のAccordionを開く
        this.accordion_agenda_kbn = true;
      }
    }

    // クエリパラメータ.会員種別
    {
      // クエリパラメータ.会員種別を取得
      const classId = this.route.snapshot.queryParams.class_id;

      // 会員種別が存在するか否か
      if (classId) {
        // 会員種別が存在する場合

        // 会員種別を画面.検索フォームに格納
        this.c201SearchForm
          .get("class_id")
          .setValue(classId.split(CONSTANT.COMMA));

        // 会員種別のAccordionを開く
        this.accordion_class_id = true;
      }
    }
  }

  /**
   * 課題・ソリューション結果を取得
   */
  public getResultTaskDataList(screenSearchFlg?: boolean): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let c201SearchForm: any = JSON.parse(
      JSON.stringify(this.c201SearchForm.value)
    );
    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(c201SearchForm) && !screenSearchFlg) {
      let sessionSearchForm = JSON.parse(
        sessionStorage.getItem(this.sessionTagName)
      );
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)) {
        // 画面の検索条件に反映する
        this.c201SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        c201SearchForm = JSON.parse(JSON.stringify(this.c201SearchForm.value));
        // 検索条件を元にアコーディオンの開閉フラグを設定
        this.setAccordionFlg(c201SearchForm);
      }
    }

    // 検索条件の地域が配列か否か
    if (c201SearchForm.prefectures) {
      // 検索条件の地域が配列の場合

      // 検索条件の地域から大項目(local_category)を削除する
      c201SearchForm.prefectures = c201SearchForm.prefectures.filter(
        (prefectures) => !prefectures.includes("local_category_")
      );
    }

    // 配列をカンマ区切り変換
    {
      c201SearchForm.member_class_sub_id =
        c201SearchForm.member_class_sub_id
          ? c201SearchForm.member_class_sub_id.toString()
          : CONSTANT.EMPTY_STRING;

      c201SearchForm.member_municipalities =
        c201SearchForm.member_municipalities
          ? c201SearchForm.member_municipalities.toString()
          : CONSTANT.EMPTY_STRING;

      c201SearchForm.agenda_solution_desired_subject =
        c201SearchForm.agenda_solution_desired_subject
          ? c201SearchForm.agenda_solution_desired_subject.toString()
          : CONSTANT.EMPTY_STRING;

      c201SearchForm.agenda_solution_target_grade =
        c201SearchForm.agenda_solution_target_grade
          ? c201SearchForm.agenda_solution_target_grade.toString()
          : CONSTANT.EMPTY_STRING;
      c201SearchForm.agenda_solution_desired_location =
        c201SearchForm.agenda_solution_desired_location
          ? c201SearchForm.agenda_solution_desired_location.toString()
          : CONSTANT.EMPTY_STRING;
      c201SearchForm.agenda_solution_desired_dayweek =
        c201SearchForm.agenda_solution_desired_dayweek
          ? c201SearchForm.agenda_solution_desired_dayweek.toString()
          : CONSTANT.EMPTY_STRING;
      c201SearchForm.freeword = c201SearchForm.freeword
        ? c201SearchForm.freeword.toString().trim()
        : CONSTANT.EMPTY_STRING;

    }
    const endpoint = this.loginUser
      ? AGENDA_SOLUTIONS_LIST
      : PUB_AGENDA_SOLUTIONS_LIST;
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(endpoint);
    const table = "view_agenda_solution_my_page";

    // 課題・ソリューション一覧を取得
    this.dbOperationService
      .getForkJoinPubDataNoTemplate(table, endpoint, c201SearchForm)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション結果を格納
          this.resultTaskDataList = response.body;
        } else {
          this.resultTaskDataList = new Array();
        }
        // 検索条件を保持
        sessionStorage.setItem(
          this.sessionTagName,
          JSON.stringify(this.c201SearchForm.value)
        );

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, endpoint);
        //return to first page
        this.dv.first = 0;
      });
    this.c201SearchForm.get("freeword")?.setValue(c201SearchForm.freeword);

    // 画面ロードフラグをON(ロード中状態)
    // this.loadingState.loadStart(AGENDA_CATEGORY_COUNT);

    // // 課題・ソリューション件数を取得
    // this.dbOperationService
    //   .getNoTemplateData(AGENDA_CATEGORY_COUNT, null, true)
    //   .subscribe((response) => {
    //     // 課題・ソリューション件数を格納
    //     this.countTaskData = response.body.count;

    //     // 画面ロードフラグをOFF(ロード終了)
    //     this.loadingState.loadSleepEnd(0.3, AGENDA_CATEGORY_COUNT);
    //   });

    // // テーブル状態が存在するか否か
    // if (this.table) {
    //   // テーブル状態が存在する場合

    //   // テーブル状態をリセット
    //   this.table.first = 0;
    // }
  }

  /**
   * カテゴリ大項目
   * @param event チェック状態
   * @param list チェック対象小項目リスト
   */
  public checkLargeCategory(
    type: string,
    list: any,
    controlName: string
  ): void {
    // 画面.検索フォーム.カテゴリを取得
    let getList = this.c201SearchForm.get(controlName).value;

    // チェック対象小項目リストからコード値のみ取得
    let spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      "sp_code"
    );
    let result = [];
    // 該当のカテゴリコードを全て削除してresult変数に格納
    if (getList) {
      result = getList.filter((value) => !spCodeList.includes(value));
    }

    // チェック状態の判定

    // チェック状態の場合
    if (type == "checkAll") {
      // result変数に選択したカテゴリコードリストを追加
      result = result.concat(spCodeList);
    } else {
      result = result.filter((val) => !spCodeList.includes(val));
    }

    // 画面.検索フォーム.地域に設定
    this.c201SearchForm.get(controlName).setValue(result);
  }

  /**
   * 地域大項目
   * @param event チェック状態
   * @param list チェック対象小項目リスト
   */
  public checkLargePrefectures(e: any, list: any): void {
    // 親イベントを止める(ヘッダ開閉)
    event.stopPropagation();

    // 画面.検索フォーム.地域を取得
    let getList = this.c201SearchForm.get("prefectures").value;

    // チェック対象小項目リストからコード名称のみ取得
    let spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      DICVALUES_API_CONSTANT.SP_NAME
    );

    // 該当の地域コードを全て削除してresult変数に格納
    let result = getList.filter((value) => !spCodeList.includes(value));

    // チェック状態の判定
    if (e.checked) {
      // チェック状態の場合

      // result変数に選択した地域コードリストを追加
      result = result.concat(spCodeList);
    }

    // 画面.検索フォーム.地域に設定
    this.c201SearchForm.get("prefectures").setValue(result);
  }

  /**
   * 地域中項目
   * @param event チェック状態
   * @param code 大項目コード
   * @param list チェック対象小項目リスト
   */
  public checkMediumPrefectures(event: any, code: string, list: any): void {
    // 画面.検索フォーム.地域を取得
    let getList = this.c201SearchForm.get("prefectures").value;

    // チェック状態の判定
    if (event.checked) {
      // チェック状態の場合

      // チェック対象小項目リストからコード名称のみ取得
      let spCodeList = this.commonService.createArrayGetArrayObject(
        list,
        DICVALUES_API_CONSTANT.SP_NAME
      );

      // チェック対象小項目リストが全てチェック状態の場合
      if (spCodeList.every((spCode) => getList.indexOf(spCode) != -1)) {
        // 画面.検索フォーム.地域に大項目コードを追加
        getList.push(code);

        // 画面.検索フォーム.地域に設定
        this.c201SearchForm.get("prefectures").setValue(getList);
      }
    } else {
      // 非チェック状態の場合

      // 画面.検索フォーム.地域から大項目コードを削除
      this.c201SearchForm
        .get("prefectures")
        .setValue(getList.filter((value) => value != code));
    }
  }

  /**
   * 課題・ソリューション詳細(C301)へ遷移する
   * @param agendaId 課題ID
   */
  public moveC301(agendaId: string): void {
    // 課題・ソリューション詳細(C301)へ遷移
    this.router.navigate(["pages/platform/c301/" + agendaId]);
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null) {
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (
        conditions["freeword_"] ||
        conditions["agenda_kbn"] ||
        conditions["class_id"] ||
        conditions["category"] ||
        conditions["prefectures"] ||
        conditions["strdate"] ||
        conditions["enddate"] ||
        conditions["industry_id"] ||
        conditions["sdgs_goal"]
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * アコーディオン表示フラグ設定
   */
  public setAccordionFlg(formVal: any): void {
    // 課題ソリューション種別
    this.accordion_agenda_kbn =
      formVal.agenda_kbn != null && formVal.agenda_kbn?.length != 0
        ? true
        : false;
    // 会員種別
    this.accordion_class_id =
      formVal.class_id != null && formVal.class_id?.length != 0 ? true : false;
    // 地域
    this.accordion_prefectures =
      formVal.prefectures != null && formVal.prefectures?.length != 0
        ? true
        : false;
    // 地域 中項目
    if (this.accordion_prefectures) {
      for (let i = 0; i < this.prefecturesList.length; i++) {
        for (let j = 0; j < this.prefecturesList[i]["list"].length; j++) {
          if (
            formVal.prefectures.indexOf(
              this.prefecturesList[i]["list"][j]["sp_name"]
            ) != -1
          ) {
            this.accordion_prefectures_detail[this.prefecturesList[i]["code"]] =
              true;
            break;
          }
        }
      }
    }
    // 更新日
    this.accordion_update_date =
      formVal.strdate != null && formVal.strdate?.length != 0
        ? true
        : formVal.enddate != null && formVal.enddate?.length != 0
          ? true
          : false;
    // 業種
    this.accordion_industry_id =
      formVal.industry_id != null && formVal.industry_id?.length != 0
        ? true
        : false;
    // SDGsゴール
    this.accordion_sdgs_goal =
      formVal.sdgs_goal != null && formVal.sdgs_goal?.length != 0
        ? true
        : false;
  }

  // NamCV5 add
  public moveC331(agenda_id?: any): void {
    this.router.navigate([`pages/platform/c331/${agenda_id}`]);
  }
  /**
   * dataView ソート処理
   */
  protected onSortChange(column: string) {
    let setOrder;
    if (this.sortField == column) {
      setOrder = this.sortOrder == 1 ? -1 : 1;
    } else {
      setOrder = 1;
    }
    this.sortOrder = setOrder;
    this.sortField = column;
  }
  // public switchModeDisplayData(event: any): void {
  //   let element = event.target;
  //   if (
  //     element.classList.contains("pi-bars") ||
  //     (element.hasChildNodes() &&
  //       element.querySelector(".pi-bars").classList.contains("pi-bars"))
  //   ) {
  //     this.isShowList = true;
  //     document.querySelector<HTMLInputElement>(".p-dataview .p-paginator-bottom").style.display = 'none';
  //   }
  //   else {
  //     this.isShowList = false;
  //     document.querySelector<HTMLInputElement>(".p-dataview .p-paginator-bottom").style.display = 'flex';
  //   }
  // }

  isDisabledTab(controlName) {
    const value = this.c201SearchForm.get(controlName).value;
    if (value == null) {
      return false;
    } else if (value.length > 0) return true;
    else return false;
  }

  /**
   * チェックボックス全選択
   */
  protected setCheckAll(dv: DataView, event: PointerEvent) {
    if (!this.allChecked) {
      this.cartSelected = new Array();
    } else {
      this.cartSelected = this.resultTaskDataList
        .map((i) => i.agenda_solution_agenda_id.toString())
        .slice(dv.first, dv.first + dv.rows);
    }
  }
  // Handle checked item checkall
  refreshCheckItems() {
    const displayItems = this.resultTaskDataList.slice(
      this.dv.first,
      this.dv.first + this.dv.rows
    );
    const totalChecked =
      displayItems.length == 0
        ? 0
        : displayItems.filter(
          (i) =>
            this.cartSelected.indexOf(
              i.agenda_solution_agenda_id.toString()
            ) !== -1
        ).length;
    this.allChecked = totalChecked == displayItems.length;
  }
  /**
   * handle change to mode choose multi
   */
  changeModeMulti(condition: boolean) {
    this.modeMulti = condition;
    if (!condition) {
      this.cartSelected = [];
      this.refreshCheckItems();
    }
  }

  /**
   * handle confirm multi
   */
  confirmMulti() {
    if (this.cartSelected.length == 0) {
      // カートが選択されていない場合
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.E90004),
      });
      return;
    }
    // if(this.cartSelected.length > 1) {
    //   this.messageService.add({
    //     severity: TOAST.ERROR,
    //     summary: this.commonService.msg(MESSAGE_CODE.E00025),
    //   })
    //   return;
    // }
    this.router.navigate(["pages/platform/c401/new"], {
      queryParams: {
        screenId: "c401",
        agenda_id: this.cartSelected.join(CONSTANT.COMMA),
        match_type: MATCH_TYPE.AGENDA_SOLUTION,
      },
    });
  }

  /**
   * check overflow of element
   * @param el html element of list
   * @returns
   */
  isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
    const isOverflowing =
      el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  isShowMediumCategory(value) {
    return this.mobileLargeCategory.some((cat) => cat == value);
  }
}
